module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Employees")]), _vm._v(" "), _c('div', {
    staticClass: "authors-list"
  }, _vm._l((_vm.employees), function(employee) {
    return _c('author', {
      key: employee.id,
      attrs: {
        "author": employee
      }
    }, [_c('router-link', {
      attrs: {
        "slot": "details-link",
        "to": {
          name: 'editorialBoardMemberDetail',
          params: {
            id: employee.id
          }
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More")])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071c6768"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/EmployeesPage.vue
// module id = 1380
// module chunks = 1